import { useFormContext } from 'react-hook-form';
import { SessionTypes } from 'redux/schemas/models/live-event';

import JoinMeetingButton from './join-meeting-button';
import ConnectAccountButton from './connect-account-button';
import MakeVirtualMeetingButton from './make-virtual-meeting-button';

import {
  getAuthenticatedAccount,
  getAuthenticatedAccounts,
  getSessionType,
  isAccountNotConfigured,
  isTokenExpired,
} from '../utils';
import {
  ALL_INTEGRATION_TYPES,
  IntegrationAuth,
} from 'redux/schemas/models/mentoring-program-sessions';

import useCalendarIntegration from 'athena/hooks/use-calendar-integration';

type VirtualMeetingButtonProps = {
  integrations: IntegrationAuth;
  openIntegrationsModal: (integrations: any) => void;
  isOnlyCalendarIntegration?: boolean;
};

const VirtualMeetingButton = (props: VirtualMeetingButtonProps) => {
  const {
    integrations,
    openIntegrationsModal,
  } = props;
  const { source = [] } = integrations || {};

  const { setValue, watch } = useFormContext() || {};
  const { joinUrl: link, sessionType: type } = watch() || {};

  const {
    hasMs365CalendarIntegration,
    isOnlyCalendarIntegration,
    isOnlyCalendarIntegrationEnabled,
    needsReauthentication,
  } = useCalendarIntegration(source);

  const hasIntegrationType = !!type;
  const hasEnabledIntegrations = source.length > 0 || hasMs365CalendarIntegration;
  const authenticatedAccounts = getAuthenticatedAccounts(integrations);

  const onRemoveMeeting = () => {
    setValue('joinUrl', '');
    setValue('sessionType', '', { shouldDirty: true });
  };

  const onMakeVirtualMeeting = (sessionType: SessionTypes) => {
    setValue('sessionType', sessionType, { shouldDirty: true });
    setValue('joinUrl', '');
  };

  let button = null;

  if (hasIntegrationType) {
    return (
      <JoinMeetingButton
        type={type}
        link={link}
        onRemove={onRemoveMeeting}
      />
    );
  } else if (authenticatedAccounts.length > 0) {
    const sessionType = authenticatedAccounts.length > 1
      ? ALL_INTEGRATION_TYPES
      : getAuthenticatedAccount(integrations);

    return (
      <MakeVirtualMeetingButton
        type={sessionType}
        onClick={onMakeVirtualMeeting}
      />
    );
  } else if (hasEnabledIntegrations) {
    const expiredAccounts = isTokenExpired(integrations);
    const notConfiguredAccounts = isAccountNotConfigured(integrations);
    const isNotConfigured = notConfiguredAccounts.length > 0;
    const isExpired = expiredAccounts.length > 0 || (isOnlyCalendarIntegrationEnabled && needsReauthentication);
    let sessionType = source.length > 1 || (source.length === 1 && hasMs365CalendarIntegration)
      ? ALL_INTEGRATION_TYPES : getSessionType(source);
    if (isOnlyCalendarIntegration) {
      sessionType = SessionTypes.MS_CALENDAR;
    } else if (expiredAccounts.length === 1 && !isNotConfigured) {
      sessionType = expiredAccounts[0].sessionType;
    }

    return (
      <ConnectAccountButton
        type={sessionType}
        isExpired={isExpired}
        onClick={() => openIntegrationsModal(integrations)}
      />
    );
  }

  return button;
};

export default VirtualMeetingButton;
